import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { debounce } from '@ember/runloop';
import { htmlSafe } from '@ember/template';
import type { SafeString } from '@ember/template';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import $ from 'jquery';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';

import Board from 'webapp/models-custom/board';

export interface ReportsViewerSlideInnerComponentInterface {
	Blocks: { default: [] }; // this is needed for yield
}

export default class ReportsViewerSlideInnerComponent extends Component<ReportsViewerSlideInnerComponentInterface> {
	_resizeFn: () => void;
	node!: HTMLElement;

	@tracked width = 0;

	// only set in construct and valid until first positioning update
	initialStyle: SafeString | string = '';

	constructor(owner: Owner, args: Record<string, never>) {
		super(owner, args);

		this.updateInnerWidth();
		this.initialStyle = htmlSafe(
			`width:${this.width}px;height:${this.height}px;font-size:${this.fontSize}px;`,
		);

		const resizeFn = () => {
			debounce(this, this.updateInnerWidth, 100);
		};
		this._resizeFn = resizeFn;

		$(window).on('resize.datawallcenter', this._resizeFn);
	}

	get height(): number {
		return (this.width * 9) / 16;
	}

	get fontSize(): number {
		return Board.getFontsizeFromWidth(this.width);
	}

	updateInnerWidth(): void {
		const ct = $('.report_slide_ct');

		if (!ct.length) {
			return;
		}

		const availableWidth = ct.width()!;
		this.width = availableWidth;

		this.updateNodeStyle();

		this.triggerResizeForBlocks();
	}

	updateNodeStyle(): void {
		const node = this.node;
		if (node) {
			node.style.fontSize = `${this.fontSize}px`;
			node.style.width = `${this.width}px`;
			node.style.height = `${this.height}px`;
		}
	}

	triggerResizeForBlocks(): void {
		$(this.node).find('.preview-block').trigger('resize.block');
	}

	@action
	setupInnerView(node: HTMLElement): void {
		this.node = node;
		this.updateInnerWidth();
	}

	@action
	teardownInnerView(): void {
		$(window).off('resize.datawallcenter', this._resizeFn);
	}
	<template>
		<div
			class="report_slide_inner"
			style={{this.initialStyle}}
			{{didInsert this.setupInnerView}}
			{{willDestroy this.teardownInnerView}}
		>
			{{yield}}
		</div>
	</template>
}
